import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_DOMINIOS_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirMunicipioRequest } from './types';

// ACTIONS
import { excluirMunicipioSuccess, excluirMunicipioFailure } from './actions';

function* excluirMunicipioRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ExcluirMunicipioRequest } = request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_DOMINIOS_API,
		`municipios/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirMunicipioSuccess(response));
	} else {
		yield put(excluirMunicipioFailure());
	}
}

export default all([
	takeLatest(Types.EXCLUIR_MUNICIPIO_REQUEST, excluirMunicipioRequest),
]);
